<template>
  <div class="sidebar border-right" :class="showSidebar ? 'shown' : 'hidden'">
    <b-overlay :show="overlay" variant="dark" :opacity="0.15" style="min-height: calc(100vh - 110px);">
      <template #overlay>
        <b-spinner class="d-none"></b-spinner>
      </template>
      <div class="d-inline-block w-100 float-left">
      <b-icon-layout-sidebar @click="toggleSidebar" variant="primary" :class="showSidebar ? 'opacity-1' : 'opacity-quarter'" class="h5 mx-3 my-2 pointer"></b-icon-layout-sidebar>
      </div>
      <hr class="mt-0 mb-3 d-inline-block w-100 float-left">
      <div class="sidebar-content px-3">
        <slot></slot>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    showSidebar: Boolean,
    overlay: Boolean
  },
  methods: {
    toggleSidebar: function () {
      this.$emit('toggleSidebar', !this.showSidebar)
    }
  }
}
</script>